import { render } from "./icon-brackets.vue?vue&type=template&id=2b313d3f"
import script from "./icon-brackets.vue?vue&type=script&lang=js"
export * from "./icon-brackets.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__